import { render, staticRenderFns } from "./PrintConfig.vue?vue&type=template&id=20c16582"
import script from "./PrintConfig.vue?vue&type=script&lang=js"
export * from "./PrintConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports